var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "bg-blue h-screen flex justify-center items-center z-2" },
    [
      _c("div", { staticClass: "signupcontainer" }, [
        _c(
          "div",
          { staticClass: "w-full flex flex-col items-center justify-center" },
          [
            _c("JobBlissLogo", { staticClass: "logo" }),
            _c("h3", { staticClass: "welcomeText" }, [
              _vm._v("Resend Confirmation Email"),
            ]),
            !_vm.emailSent
              ? _c("ValidationObserver", {
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function ({ invalid, dirty, handleSubmit }) {
                          return [
                            _c("div", { staticClass: "fromWidth" }, [
                              _c(
                                "form",
                                {
                                  on: {
                                    submit: function ($event) {
                                      $event.preventDefault()
                                      return handleSubmit(_vm.submit)
                                    },
                                  },
                                },
                                [
                                  _c("ValidationProvider", {
                                    attrs: {
                                      name: "Email address",
                                      rules: "c_email|required",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ errors }) {
                                            return [
                                              _c("FormGroup", {
                                                attrs: {
                                                  id: "username",
                                                  name: "Email address",
                                                  type: "email",
                                                  inputClass:
                                                    "fullwidthInput customSignText",
                                                  isIcon: false,
                                                  placeholder:
                                                    "Enter your email",
                                                  errors: errors,
                                                },
                                                model: {
                                                  value: _vm.emailValue,
                                                  callback: function ($$v) {
                                                    _vm.emailValue =
                                                      typeof $$v === "string"
                                                        ? $$v.trim()
                                                        : $$v
                                                  },
                                                  expression: "emailValue",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("UiButton", {
                                    staticClass: "mt-7",
                                    attrs: {
                                      buttonClasses: "customPadding fontButton",
                                      buttonText: "Submit",
                                      type: "submit",
                                      variant: "black",
                                      fullWidth: "",
                                      processing: _vm.loading,
                                      disabled: invalid || !dirty,
                                    },
                                  }),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex justify-center itmes-center mt-7",
                                    },
                                    [
                                      _c("AuthFormLink", {
                                        staticClass:
                                          "inline text-sm font-outfit text-center",
                                        attrs: {
                                          link: "/signin",
                                          text: "Return to Sign In",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    1998286413
                  ),
                })
              : _c(
                  "p",
                  { staticClass: "text-center" },
                  [
                    _vm._v(
                      " Confirmation was successfully sent to the " +
                        _vm._s(_vm.emailValue) +
                        ". Please, check your inbox and follow the instructions described there. "
                    ),
                    _c("AuthFormLink", {
                      staticClass: "text-base",
                      attrs: { link: "/signin", text: "Go to Sign In" },
                    }),
                  ],
                  1
                ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }